import { Component,Input, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { LoginForm } from '../loginForm';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { LoginService } from '../login.service';
import { ApiRequestService } from '../../shared/api-request-service';
import { catchError } from 'rxjs/operators';
import { LoginData } from '../login-data';
import { throwError } from 'rxjs';
import { Buffer } from 'buffer';
import { PersonalData } from '../../shoppingcart/contact/personal-data';
import { MyOrdersRequest } from '../myorders/myordersrequest';
import { PersonalDataResponse } from '../personaldataResponse';
import { DataDialog } from '../verification/dataDialog';
import { TranslationService } from '../../translation/translation.service';
import { ShoppingcartService } from '../../shoppingcart/shoppingcart.service';
import { Material } from '../../shoppingcart/material';
import { HttpError } from '../../shared/httperror';
import { MAT_ICON, TOAST_STATE, ToastmessageService } from '../../toastmessage/toastmessage.service';

@Component({
    selector: 'lib-signin',
    templateUrl: './signin.component.html',
    styleUrls: ['./signin.component.scss']
})
export class SigninComponent {
    selectedAlign: 'start' | 'center' | 'end';
    errorMessage = '';
    loginForm?: FormGroup;
    loginObject?: LoginForm = {};;
    passwordRegex = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])/;
    @Input() admin = false;
    errorMessagee = '';
    password = 'kiscica86B';

    token = '1233hjghjghjg34_.!';

    username = 'info@multiverzumkiado.hu';

    loginBaseUrl = '';

    redirectUrl = "";

    //this is a default Spring Boot controller url for oauth2
    loginUrl = '/oauth2/token';

    oauthToken: LoginData = {};

    errorLoginMessage = '';

    @Input() hasCityAndZipUrl = true;

    getPersonalDataUrl = '/getpersonaldata';

    loggedInPersonalData?: PersonalData;

    material: Material = {};

    loginErrorToastMessage= "Nem megfelelő felhasznáűlónév vagy jelszó";

    scope = "";

    constructor(
        @Inject(MAT_DIALOG_DATA) public dataDialog: DataDialog,
        @Inject('AUTH_BACKEND_URL') private _loginUrl: string,
        private _apiRequestService: ApiRequestService,
        private _dialog: MatDialog,
        private _fb: FormBuilder,
        private _http: HttpClient,
        private _router: Router,
        private _loginService: LoginService,
        private _translateService: TranslationService,
        private _shoppingcartService: ShoppingcartService,
        private _toastMessageService:ToastmessageService
    ) {
        this.selectedAlign = 'end';
        this.createLoginForm();
        this.loginBaseUrl = _loginUrl;
    }
    ngOnInit(): void {
        if (sessionStorage.getItem('token')) {
            sessionStorage.removeItem('token');
        }
    }

    closeDialog() {
        this._dialog.closeAll();
    }

    createLoginForm() {
        this.loginForm = this._fb.group({
            email: ['', [Validators.required, Validators.email, Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$')]],
            password: ['', [Validators.required, Validators.pattern(this.passwordRegex)]]
        });
    }

    collectLoginData() {
        this.loginObject = {
            email: this.loginForm?.controls['email'].value as string | undefined,
            password: this.loginForm?.controls['password'].value as string | undefined
        };
    }

    login(redirectUrl: string) {
        this.collectLoginData();

        sessionStorage.setItem('clientId', JSON.stringify(this.loginObject?.email));

        const headers = new HttpHeaders()
            .set('Content-type', 'application/x-www-form-urlencoded; charset=utf-8')
            .set('Authorization', 'Basic ' + Buffer.from(this.loginObject?.email + ':' + this.loginObject?.password).toString('base64'));

        if(this.admin) {
            this.scope = 'PW_ADMIN';
        }
        else {
            this.scope = 'PW_CLIENT';

        }

        const body = 'grant_type=client_credentials&scope='+this.scope;
        this._http
            .post(this.loginBaseUrl + this.loginUrl, body, { headers })
            .pipe(
                catchError((error: HttpErrorResponse) => {
                    return throwError(() => {
                        const httpError:HttpError = error.error as HttpError;
                        if (error.status === 422) {
                            alert(this._translateService.translate(httpError.errorMessage!));

                        }
                        this._toastMessageService.displayToastMessage(TOAST_STATE.warning, this.loginErrorToastMessage,MAT_ICON.warning);
                        //close toast message
                        this.dismissError();


                    })
                })
            )
            .subscribe((data) => {
                const loggedInUserPersonalDataRequest = {
                    clientId: this.loginObject?.email!
                };
                this.oauthToken = data as LoginData;
                sessionStorage.setItem('token', JSON.stringify(this.oauthToken));
                this._router.navigateByUrl(redirectUrl);

                this._dialog.closeAll();
                //put PersonalData to session to fill the form automatic on /contact
                this._apiRequestService
                    .sendRequest<MyOrdersRequest, PersonalDataResponse>(
                        this.loginBaseUrl,
                        true,
                        loggedInUserPersonalDataRequest,
                        true,
                        this.getPersonalDataUrl
                    )
                    .subscribe((answer) => {
                        sessionStorage.setItem('personalData', JSON.stringify(answer.client));

                        if (sessionStorage.getItem('material')) {
                            this._shoppingcartService.addToCart(JSON.parse(sessionStorage.getItem('material') as string) as Material);
                            sessionStorage.removeItem('material');
                        }


                    });
            });
    }

    openRegistration() {
        this._dialog.closeAll();
        this._loginService.openRegistration();
    }

    openForgotPassword() {
        this._dialog.closeAll();
        this._loginService.openForgotPassword();
    }

    private dismissError(): void {
        setTimeout(() => {
            this._toastMessageService.dismissToast();
        }, 3000);
    }
}
